// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1IhHA","additionalInfo":"AgreementModal_additionalInfo__1mZG_"};